module.exports = __webpack_public_path__ + "img/kb-image.048754f5.jpg";